// actions
export const actions = {
  COUPON_EDITING: 'COUPON_EDITING',
  NO_COUPON: 'NO_COUPON',
  COUPON_RESOLVED_SUCCESS: 'COUPON_RESOLVED_SUCCESS',
  COUPON_RESOLVED_ERROR: 'COUPON_RESOLVED_ERROR',
  COUPON_ADD_ACTION: 'COUPON_ADD_ACTION',
  COUPON_REMOVE_ACTION: 'COUPON_REMOVE_ACTION',
};

export const couponState = {
  unknown: 'unknown',
  noCoupon: 'noCoupon',
  couponSuccessful: 'couponSuccessful',
  couponError: 'couponError',
  couponEditing: 'couponEditing',
};

export const couponUserActions = {
  add: 'add',
  remove: 'remove',
};

// reducers
export const initialState = {
  // coupon not resolved with server
  isResolving: true,
  // Coupon status based on actions
  couponStatus: couponState.unknown,
  currentAction: couponUserActions.add,
  serverError: null,
  isInputCodeValid: true,
  newCoupon: '',
  hasErrors: false,
  resolvedCoupon: null,
};

export function useCouponProcessorReducer(state, action) {
  switch (action.type) {
    case actions.COUPON_EDITING: {
      return {
        ...state,
        couponStatus: couponState.couponEditing,
        newCoupon: action.newCoupon,
        isInputCodeValid: action.isValid,
        serverError: null,
        hasErrors: !action.isValid,
        isResolving: false,
        resolvedCoupon: action.coupon,
      };
    }
    case actions.COUPON_ADD_ACTION: {
      return {
        ...state,
        couponStatus: couponState.couponEditing,
        serverError: null,
        hasErrors: false,
        isInputCodeValid: true,
        isResolving: true,
        resolvedCoupon: action.coupon,
      };
    }
    case actions.COUPON_REMOVE_ACTION: {
      return {
        ...state,
        couponStatus: couponState.couponEditing,
        serverError: null,
        newCoupon: '',
        isInputCodeValid: true,
        isResolving: true,
        hasErrors: false,
        resolvedCoupon: null,
      };
    }
    case actions.NO_COUPON: {
      return {
        ...state,
        couponStatus: couponState.noCoupon,
        serverError: null,
        isInputCodeValid: true,
        isResolving: false,
        currentAction: couponUserActions.add,
        hasErrors: false,
        resolvedCoupon: action.coupon,
      };
    }
    case actions.COUPON_RESOLVED_SUCCESS: {
      return {
        ...state,
        couponStatus: couponState.couponSuccessful,
        serverError: null,
        isInputCodeValid: true,
        isResolving: false,
        newCoupon: '',
        hasErrors: false,
        currentAction: couponUserActions.remove,
        resolvedCoupon: action.coupon,
      };
    }
    case actions.COUPON_RESOLVED_ERROR: {
      return {
        ...state,
        couponStatus: couponState.couponError,
        serverError: action.error,
        newCoupon: '',
        isInputCodeValid: true,
        isResolving: false,
        currentAction: couponUserActions.add,
        hasErrors: !!action.error,
        resolvedCoupon: action.coupon,
      };
    }
    default:
      throw new Error();
  }
}
